module.exports = __webpack_public_path__ + "static/Folio-Medium-fb7b6e46fefec3a23e822f934a94d53d.woff2";